import React, { Fragment } from "react";
import { withStyles, Button, Tooltip } from "@material-ui/core";
import RestoreIcon from "@material-ui/icons/Restore";
import DataGrid from "../../../../dataGrid"
import GridConfig from "./gridConfig";
import styles from "../../styles";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { postData} from "../../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import { observer, inject } from "mobx-react";
import Events from "../../../../../utilities/EventEmitter";
import appConstant from "../../../../../appConstants";
import MESSAGES from "../../../../../appMessages";

@inject("CommonStore")
@observer
class Parameters extends React.Component {
    constructor(props){
        super(props);
        this.gridConfig = new GridConfig();
        this.state= {
            terminalID : this.props.userData.userProfile.terminal.id,
            parameterData: null,
            errorMessage: null
        }
    }


    onGridReady = ({api}) => {
        this.gridApi = api;
    }

    onCellValueChanged = (params) => {
        if(params.oldValue !== params.newValue && !(params.oldValue === null && params.newValue === "")){
            this.updateParameterCustomValue(params);
        }
    }

    updateParameterCustomValue = (params) => {
        const {scenarioID} = this.props.userData.userProfile;
        const requestParams = {
            scenarioId: scenarioID,
            parameterList:[{
                parameterId: params.data.parameterId,
                value: params.newValue === appConstant.EMPTY_STRING ? null : params.newValue
            }]
        }
        postData("UpdateParameters", requestParams).then(response =>{
            if(Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(MESSAGES.PARAMETERS.UPDATE_SUCCESS, {variant: "success"});
                Events.emit("updateParametersData",scenarioID);
            } else {
                this.props.enqueueSnackbar(MESSAGES.PARAMETERS.UPDATE_FAILURE, {variant: "error"});
                params.data[params.colDef.field] = params.oldValue;
                this.gridApi.refreshCells();
            }
        }, error => {
            this.props.enqueueSnackbar(MESSAGES.PARAMETERS.UPDATE_FAILURE, {variant: "error"});
            params.data[params.colDef.field] = params.oldValue;
            this.gridApi.refreshCells();
        })
    }


    render(){
        const { classes } = this.props;
        const  parametersData = this.props.CommonStore.parametersData ? this.props.CommonStore.parametersData.slice().filter(parameter => parameter.isVisible) : [];
        return (
            <Fragment>
                <header className={classes.moduleHeader}  data-automationid="parameters-title"> Optimization Parameters </header>
                <div className={classes.moduleContainer}>
                    <div className={classes.moduleMessage}>
                        Optimization parameters affect the results of the optmization modes offered in RouteMAX. Note: We recommend not changing these values.
                    </div>
                    <div className={`${classes.gridContainer} ${classes.parameterGridContainer}`}>
                        <div className={`${classes.dataGrid} ${classes.parameterGrid}`}>
                        {!this.state.errorMessage ? (
                            <DataGrid
                                columnDefs={this.gridConfig.config.columns}
                                config={this.gridConfig.config}
                                enableFilter={this.gridConfig.config.enableFilter}
                                enableSorting={this.gridConfig.config.enableSorting}
                                rowData={parametersData}
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChanged}
                            />
                            ): (
                                <div className={classes.errorMessageContainer}>
                                        <div className={classes.errorMessage}> {this.state.errorMessage} </div>
                                </div>
                            )}

                        </div>
                    </div>
                    <div >
                        <Button color="primary" variant="contained" size="small" classes={{root: classes.actionButton, disabled: classes.actionDisabled}} disabled>
                           <RestoreIcon classes={{root: classes.restoreIcon}} /> Restore to Defaults
                        </Button>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default compose(withStyles(styles), withUserProfile, withSnackbar)(Parameters)